import { Box } from '@mui/material';
import { type ReactElement } from 'react';
import { LineChart, ResponsiveContainer, XAxis } from 'recharts';
import { convertUtcToDisplayTime } from 'utils/helpers/dateTime';
import useTimeDisplayMode from 'hooks/useTimeDisplayMode';
import useAppTheme from 'hooks/useAppTheme';
import { DATE_FORMAT } from 'utils/constants/dateTime';

export function LineChartHOC({
  children,
  data,
  xaxisDataKey,
}: {
  children: ReactElement | ReactElement[] | any;
  data: any[];
  xaxisDataKey: string;
}) {
  const { preferredTimeDisplayMode, timezone } = useTimeDisplayMode();
  const { enableDarkTheme } = useAppTheme();
  return (
    <Box
      sx={{
        width: '100%',
        height: '400px',
        mt: 1,
        mb: 1,
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          {children}
          <XAxis
            dataKey={xaxisDataKey}
            tick={{
              fill: enableDarkTheme
                ? 'rgba(255, 255, 255, 0.7)'
                : 'rgba(0, 0, 0, 0.65)',
              fontSize: 11,
            }}
            axisLine={{
              stroke: enableDarkTheme
                ? 'rgba(255, 255, 255, 0.2)'
                : 'rgba(0, 0, 0, 0.15)',
            }}
            tickFormatter={(value) => {
              try {
                return convertUtcToDisplayTime(
                  value,
                  preferredTimeDisplayMode,
                  timezone,
                  DATE_FORMAT
                );
              } catch {
                return value;
              }
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default LineChartHOC;
